export enum PurchaseCouponActionTypes {
    REQUEST = '@@coupon/purchase/request',
    SUCCESS = '@@coupon/purchase/success',
    ERROR = '@@coupon/purchase/error'
}
